import { parseAsString, useQueryState } from 'nuqs';

export const useChatId = () => {
  const [chatId, setChatId] = useQueryState('chatId', parseAsString);

  return {
    chatId,
    setChatId,
  };
};
